var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLittleArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.34668 0.883789C5.34668 0.646484 5.16504 0.479492 4.875 0.479492L1.11914 0.476562C0.832031 0.476562 0.650391 0.643555 0.650391 0.880859C0.650391 1.00391 0.703125 1.10645 0.770508 1.24707L2.55469 4.93848C2.68359 5.19922 2.81543 5.29883 2.99707 5.29883C3.17871 5.29883 3.31348 5.19922 3.44238 4.93848L5.22656 1.24707C5.29395 1.10938 5.34668 1.00684 5.34668 0.883789Z",
    fill: "#BFBBCF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLittleArrowDown);
export default __webpack_public_path__ + "static/media/icon-little-arrow-down.3714a390f426cb4aab6786b06afa6873.svg";
export { ForwardRef as ReactComponent };